"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TouchedBy = void 0;
class TouchedBy {
}
exports.TouchedBy = TouchedBy;
//# sourceMappingURL=touched-by.js.map